<template>
    <div>
        <!-- Modal Log Integração -->
        <div class="modal fade" id="logIntModalSigaCall" tabindex="-1" role="dialog" aria-labelledby="modelTitleIdSigaCall" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Logs de Integração</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!logsSigaCall || !logsSigaCall.length" :loading="loading" msg="Nenhum log registrados" icon="fa-solid fa-comment-dots"></az-empty-state>

                        <div v-else>
                            <table class="table table-responsive">
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Data</th>
                                        <th v-if="exibir_json">{{ format }}</th>
                                        <th>Resposta</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="log in logsSigaCall" :key="log.id_log_integracao">
                                        <td class="text-nowrap">
                                            <i class="fa fa-check-circle text-success fa-fw mr-2" aria-hidden="true" v-if="log.fl_sucesso"></i>
                                            <i class="fa fa-times-circle text-danger fa-fw mr-2" aria-hidden="true" v-else></i>
                                            #{{ log.id_log_integracao }}</td>
                                        <td class="text-nowrap">
                                            <span v-if="log.created_at">
                                                {{ $util.getFormatDate(log.created_at) }}
                                                {{ log.created_at.slice(11,16) }}
                                            </span>
                                            <div class="small text-muted" v-if="log.usuario">{{ log.usuario.st_login }}</div>
                                        </td>
                                        <td v-if="exibir_json">
                                            <template v-if="log.js_parms && log.js_parms != 'null'">
                                                <div class="d-flex justify-content-between text-nowrap">
                                                    <div class="small">
                                                        <a href="#" :class="view_retorno == 'T' ? 'font-weight-bold' : ''" @click.prevent="view_retorno = 'T'">
                                                            Texto
                                                        </a>
                                                        <template v-if="format == 'Json'">
                                                            | 
                                                            <a  href="#" :class="view_retorno == 'F' ? 'font-weight-bold' : ''" @click.prevent="view_retorno = 'F'">
                                                                Formatado
                                                            </a>
                                                        </template>
                                                        | 
                                                        <a href="#" :class="view_retorno == 'O' ? 'font-weight-bold' : ''" @click.prevent="view_retorno = 'O'">
                                                            Ocultar
                                                        </a>
                                                    </div>
                                                </div>

                                                <div class="alert alert-warning" v-if="view_retorno == 'F'">
                                                    <vue-json-pretty :data="parse_json(log.js_parms)" :showLength="true" />
                                                </div>

                                                <pre class="alert alert-warning text-wrap w-100" v-else-if="view_retorno == 'T'">{{ log.js_parms }}</pre>
                                            </template>

                                            <div class="small">
                                                {{ log.st_url }}
                                            </div>
                                        </td>

                                        <!-- Resposta -->
                                        <td>
                                            <template v-if="log.retorno_json">
                                                <div class="d-flex justify-content-between text-nowrap">
                                                    <div class="small">
                                                        <a href="#" :class="view_resposta == 'T' ? 'font-weight-bold' : ''" @click.prevent="view_resposta = 'T'">
                                                            Texto
                                                        </a>
                                                        <template v-if="format == 'Json'">
                                                            | 
                                                            <a  href="#" :class="view_resposta == 'F' ? 'font-weight-bold' : ''" @click.prevent="view_resposta = 'F'">
                                                                Formatado
                                                            </a>
                                                        </template>
                                                        | 
                                                        <a href="#" :class="view_resposta == 'O' ? 'font-weight-bold' : ''" @click.prevent="view_resposta = 'O'">
                                                            Ocultar
                                                        </a>
                                                    </div>
                                                </div>

                                                <div class="alert alert-warning" v-if="view_resposta == 'F'">
                                                    <vue-json-pretty :data="parse_json(log.retorno_json)" :showLength="true" />
                                                </div>

                                                <pre class="alert alert-warning text-wrap w-100" v-else-if="view_resposta == 'T'">{{ log.retorno_json }}</pre>
                                            </template>

                                            <template v-else>
                                                {{ log.st_mensagem }}
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
    data() { 
        return { 
            logsSigaCall: [], 
            loading: false,
            exibir_json: false,
            view_retorno: 'O',
            view_resposta: 'O',
            format: 'Json'
        }
    },

    components: { 
        AzEmptyState,
        VueJsonPretty
    },

    methods: { 
        abrir(model_type, model_id, exibir_json = false, format = 'Json') { 
            
            this.logsSigaCall = null; 
            this.exibir_json = exibir_json;
            this.format = format;

            $('#logIntModalSigaCall').modal('show');

            this.$util.load(this, { 
                service: 'log_integracaos',
                func: 'index', 
                parms: { 
                    model_type: model_type,
                    model_id: model_id
                },
                loadTo: res => { 
                    this.logsSigaCall = res;
                }
            });
        },

        fechar_modal() { 
            $('#logIntModalSigaCall').modal('hide');
        },

        parse_json (array) {
            const texto = JSON.stringify(array)
            return JSON.parse(texto);
        },
    }
}
</script>